import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, FullBar } from "cakemail-ui-components/lib/react";
import { Translate } from "react-redux-i18n";
import PropTypes from "prop-types";
import BrandElement from "assets/js/scenes/brand/components/brandElements/BrandElement";
import BrandLink from "assets/js/scenes/brand/components/brandElements/BrandLink";
import { showResetDialog } from "assets/js/scenes/brand/utils";

const basePath = "url";
let key = new Date().getTime();
export const Links = (props) => {
	const base = props.localBrand?.url;
	const originalBase = props.brand?.url;

	function reset() {
		function resetConfirm() {
			props.resetTabData(basePath);
			key = new Date().getTime();
		}

		showResetDialog(
			<Translate value="app-brand-modal-tab-link-reset" />,
			<p>
				<Translate
					value="app-brand-modal-tab-colors-link-desc"
					resellerName={props.resellerName}
				/>
			</p>,
			resetConfirm
		);
	}

	return (
		<div className="brandModalTabContent Links" key={key}>
			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tabs-links-general" />
					</p>
				}
				right={
					<Button
						shapeStyle="stroke"
						colorTheme="grey"
						text={<Translate value="app-brand-modal-tab-link-reset" />}
						onClick={reset}
					/>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={<Translate value="app-brand-links-billing-plans-title" />}
					desc={<Translate value="app-brand-links-billing-plans-desc" />}
					path={basePath + ".plan_upgrade.en"}
					rightPanel={
						<BrandLink
							link={base["plan_upgrade"]?.en}
							path={basePath + ".plan_upgrade.en"}
							defaultLink={originalBase["plan_upgrade"]?.en}
						/>
					}
				/>
				<BrandElement
					title={<Translate value="app-brand-links-referral-title" />}
					desc={<Translate value="app-brand-links-referral-desc" />}
					path={basePath + ".referral_badge.en"}
					rightPanel={
						<BrandLink
							link={base["referral_badge"]?.en}
							path={basePath + ".referral_badge.en"}
							defaultLink={originalBase["referral_badge"]?.en}
						/>
					}
				/>
			</div>

			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tabs-links-legal" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={<Translate value="app-general-terms-service" />}
					desc={<Translate value="app-brand-links-terms-desc" />}
					path={basePath + ".terms_url.en"}
					rightPanel={
						<BrandLink
							link={base["terms_url"]?.en}
							path={basePath + ".terms_url.en"}
							defaultLink={originalBase["terms_url"]?.en}
						/>
					}
				/>
				<BrandElement
					title={<Translate value="app-general-anti-spam" />}
					desc={<Translate value="app-brand-links-anti-spam-desc" />}
					path={basePath + ".anti_spam_url.en"}
					rightPanel={
						<BrandLink
							link={base["anti_spam_url"]?.en}
							path={basePath + ".anti_spam_url.en"}
							defaultLink={originalBase["anti_spam_url"]?.en}
						/>
					}
				/>
				<BrandElement
					title={<Translate value="app-general-privacy-policy" />}
					desc={<Translate value="app-brand-links-privacy-desc" />}
					path={basePath + ".privacy_url.en"}
					rightPanel={
						<BrandLink
							link={base["privacy_url"]?.en}
							path={basePath + ".privacy_url.en"}
							defaultLink={originalBase["privacy_url"]?.en}
						/>
					}
				/>
			</div>

			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tabs-links-support" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={<Translate value="app-brand-links-support-KB-title" />}
					desc={<Translate value="app-brand-links-support-KB-desc" />}
					path={basePath + ".help_url.en"}
					rightPanel={
						<BrandLink
							link={base["help_url"]?.en}
							path={basePath + ".help_url.en"}
							defaultLink={originalBase["help_url"]?.en}
						/>
					}
				/>
				<BrandElement
					title={
						<Translate value="app-brand-links-support-email-designer-title" />
					}
					desc={
						<Translate value="app-brand-links-support-email-designer-desc" />
					}
					path={basePath + ".email_designer_help.en"}
					rightPanel={
						<BrandLink
							link={base["email_designer_help"]?.en}
							path={basePath + ".email_designer_help.en"}
							defaultLink={originalBase["email_designer_help"]?.en}
						/>
					}
				/>

				<BrandElement
					title={<Translate value="app-brand-links-support-call-title" />}
					desc={<Translate value="app-brand-links-support-call-desc" />}
					path={basePath + ".schedule_help_url.en"}
					rightPanel={
						<BrandLink
							link={base["schedule_help_url"]?.en}
							path={basePath + ".schedule_help_url.en"}
							defaultLink={originalBase["schedule_help_url"]?.en}
						/>
					}
				/>
			</div>

			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tabs-links-kb" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={
						<Translate value="app-brand-links-KB-required-content-title" />
					}
					desc={<Translate value="app-brand-links-KB-required-content-desc" />}
					path={basePath + ".address_mergetag_kb_url.en"}
					rightPanel={
						<BrandLink
							link={base["address_mergetag_kb_url"]?.en}
							path={basePath + ".address_mergetag_kb_url.en"}
							defaultLink={originalBase["address_mergetag_kb_url"]?.en}
						/>
					}
				/>
				<BrandElement
					title={
						<Translate value="app-brand-links-KB-personalized-subject-title" />
					}
					desc={
						<Translate value="app-brand-links-KB-personalized-subject-desc" />
					}
					path={basePath + ".kb_boost_1.en"}
					rightPanel={
						<BrandLink
							link={base["kb_boost_1"]?.en}
							path={basePath + ".kb_boost_1.en"}
							defaultLink={originalBase["kb_boost_1"]?.en}
						/>
					}
				/>

				<BrandElement
					title={<Translate value="app-brand-links-KB-boost-segment-title" />}
					desc={<Translate value="app-brand-links-KB-boost-segment-desc" />}
					path={basePath + ".kb_boost_segment.en"}
					rightPanel={
						<BrandLink
							link={base["kb_boost_segment"]?.en}
							path={basePath + ".kb_boost_segment.en"}
							defaultLink={originalBase["kb_boost_segment"]?.en}
						/>
					}
				/>

				<BrandElement
					title={<Translate value="app-brand-links-KB-choose-sender-title" />}
					desc={<Translate value="app-brand-links-KB-choose-sender-desc" />}
					path={basePath + ".kb_choose_sender_email.en"}
					rightPanel={
						<BrandLink
							link={base["kb_choose_sender_email"]?.en}
							path={basePath + ".kb_choose_sender_email.en"}
							defaultLink={originalBase["kb_choose_sender_email"]?.en}
						/>
					}
				/>

				<BrandElement
					title={<Translate value="app-brand-links-KB-protect-account-title" />}
					desc={<Translate value="app-brand-links-KB-protect-account-desc" />}
					path={basePath + ".protect_account_kb_url.en"}
					rightPanel={
						<BrandLink
							link={base["protect_account_kb_url"]?.en}
							path={basePath + ".protect_account_kb_url.en"}
							defaultLink={originalBase["protect_account_kb_url"]?.en}
						/>
					}
				/>

				<BrandElement
					title={<Translate value="app-brand-links-KB-unsubscribe-tag-title" />}
					desc={<Translate value="app-brand-links-KB-unsubscribe-tag-desc" />}
					path={basePath + ".unusubcribe_mergetag_kb_url.en"}
					rightPanel={
						<BrandLink
							link={base["unusubcribe_mergetag_kb_url"]?.en}
							path={basePath + ".unusubcribe_mergetag_kb_url.en"}
							defaultLink={originalBase["unusubcribe_mergetag_kb_url"]?.en}
						/>
					}
				/>
			</div>
		</div>
	);
};

/*
<BrandElement
					title={<Translate value="app-brand-links-support-contact-us-title"/>}
					desc={<Translate value="app-brand-links-support-contact-us-desc"/>}
					path={basePath + ".contact_us_url.en"}
					rightPanel={<BrandLink link={base["contact_us_url"]?.en} path={basePath + ".contact_us_url.en"} defaultLink={originalBase["contact_us_url"]?.en}/>}/>
 */

Links.propTypes = {
	localBrand: PropTypes.object,
	brand: PropTypes.object,
	resetTabData: PropTypes.func,
	resellerName: PropTypes.string,
};

Links.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				//Only Reseller otherwise use getCurrentBrandFromState(state)
				brand: state.brand,
				localBrand: state.localBrand.data,
				resellerName: state.brand?.name,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(Links)
);
